/* unplugin-vue-components disabled */import { render } from "./NavbarAvatar.vue?vue&type=template&id=9f82558c&scoped=true&ts=true"
import script from "./NavbarAvatar.vue?vue&type=script&lang=ts"
export * from "./NavbarAvatar.vue?vue&type=script&lang=ts"

import "./NavbarAvatar.vue?vue&type=style&index=0&id=9f82558c&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f82558c"]])

export default __exports__